/*

 使用 ： 

 1. 导入组件
 2. 定义属性和方法
  const [CountDownOpen, setCountDownOpen] = useState(true)
  const complete = () => {
    console.log('倒计时结束', CountDownOpen)
    setCountDownOpen(false)
  }

  3. 渲染组件
<CountDownMask openstatus={CountDownOpen} complete={complete}></CountDownMask>


*/

import React, { useState, useEffect, useRef, forwardRef } from 'react';
import './index.less';
import { message } from 'antd';
import { useImperativeHandle } from 'react';

const ScreenRecorder = forwardRef((props, ref) => {
  const { openstatus, complete, disComplete, isStop } = props;
  const [statusNumber, setStatusNumber] = useState(3);
  const [hasOK, setHasOK] = useState(false);

  let timer1 = useRef(null);
  let timer2 = useRef(null);
  let timer3 = useRef(null);

  const start = () => {
    // 1. 初始化数据
    setStatusNumber(3);
    // 2. 控制滚动条不滚动
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '0px';
    document.body.style.width = '“100%';

    // 3. 开始执行动画
    timer1.current = setTimeout(() => {
      setStatusNumber(2);
      timer2.current = setTimeout(() => {
        setStatusNumber(1);
        timer3.current = setTimeout(() => {
          // 执行回调
          setHasOK(true);
          stop();
        }, 1000);
      }, 1000);
    }, 1000);
  };

  useImperativeHandle(ref, () => ({
    stopped,
  }));

  const stopped = () => {
    clearTimeout(timer1.current);
    clearTimeout(timer2.current);
    clearTimeout(timer3.current);
    document.documentElement.style.overflow = 'auto';
    document.body.style.position = 'static';
    setStatusNumber(3);
    setHasOK(false);
    //stop();
  };

  const stop = () => {
    complete();
    // setHasOK(false)
    document.documentElement.style.overflow = 'auto';
    document.body.style.position = 'static';
    setStatusNumber(3);
  };
  useEffect(() => {
    if (openstatus) {
      start();
    }
  }, [openstatus]);

  useEffect(() => {
    console.log('----------------', isStop, hasOK);
    if (isStop) {
      if (!hasOK) {
        disComplete();
        clearTimeout(timer1.current);
        clearTimeout(timer2.current);
        clearTimeout(timer3.current);
        document.documentElement.style.overflow = 'auto';
        document.body.style.position = 'static';
        setStatusNumber(3);
        setHasOK(false);
      } else {
        setHasOK(false);
      }
    }
  }, [isStop]);

  return (
    <div>
      {openstatus && (
        <div className='count-down-mask'>
          <div className='mask'></div>
          <div className='number'>{statusNumber}</div>
        </div>
      )}
    </div>
  );
});

export default ScreenRecorder;
